export default __webpack_public_path__ + "static/media/190.d77167cd.jpg";